export default __webpack_public_path__ + "static/media/SWT1330.34I-40896_-24202_0.e2c7d8b3.jpg";